import React from "react";
import { FiLogOut, FiUser, FiMenu } from "react-icons/fi";
import { motion } from "framer-motion";
import { theme } from "../theme";
import { useAuth0 } from "@auth0/auth0-react";
import { useBreakpoint } from "../hooks/useBreakpoint";

interface NavbarProps {
  onMenuToggle?: () => void;
}

export const Navbar = ({ onMenuToggle }: NavbarProps) => {
  const { logout, user } = useAuth0();
  const { isMobile, isMobileOrTablet } = useBreakpoint();

  const handleLogout = () => {
    if (window.confirm('¿Está seguro que desea cerrar sesión?')) {
      logout({ logoutParams: { returnTo: window.location.origin } });
    }
  };

  return (
    <motion.nav
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="flex items-center sticky top-0 z-50"
      style={{
        backgroundColor: '#ffffff',
        boxShadow: theme.styles.boxShadow,
        padding: isMobile ? '8px 12px' : '12px 16px',
        gap: '8px',
      }}
    >
      {/* Botón hamburguesa en móvil/tablet */}
      {isMobileOrTablet && (
        <button
          onClick={onMenuToggle}
          style={{
            color: theme.colors.primaryDark,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '22px',
            padding: '4px',
            flexShrink: 0,
          }}
          aria-label="Abrir menú"
        >
          {/* @ts-ignore */}
          <FiMenu />
        </button>
      )}

      {/* Título */}
      {!isMobile && (
        <h1
          style={{
            fontSize: isMobileOrTablet ? '14px' : theme.fontSizes.large,
            fontWeight: 600,
            color: theme.colors.primaryDark,
            margin: 0,
            flex: 1,
            textAlign: 'center',
          }}
        >
          Grupo <span style={{ color: theme.colors.secondary }}>Servisoft</span> - Algodón
        </h1>
      )}

      {isMobile && <div style={{ flex: 1 }} />}

      {/* Información del usuario y logout */}
      <div className="flex items-center gap-2" style={{ flexShrink: 0 }}>
        {user && !isMobile && (
          <div
            className="flex items-center gap-2"
            style={{
              padding: '6px 10px',
              backgroundColor: '#f5f5f5',
              borderRadius: '8px',
            }}
          >
            {/* @ts-ignore */}
            <FiUser style={{ color: theme.colors.primary, flexShrink: 0 }} />
            <div style={{ lineHeight: '1.4', maxWidth: isMobileOrTablet ? '150px' : undefined }}>
              <div
                style={{
                  fontSize: '13px',
                  fontWeight: 600,
                  color: theme.colors.primaryDark,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {user.email || user.name}
              </div>
              {!isMobileOrTablet && user.empresa && (
                <div style={{ fontSize: '11px', color: '#6b7280', paddingLeft: '2px' }}>
                  Empresa: {user.empresa}
                </div>
              )}
              {!isMobileOrTablet && user.desmotadora && (
                <div style={{ fontSize: '11px', color: '#6b7280', paddingLeft: '2px' }}>
                  Desmotadora: {user.desmotadora}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Botón de logout */}
        <motion.button
          whileHover={{ scale: 1.1 }}
          onClick={handleLogout}
          className="text-xl"
          style={{
            color: theme.colors.error,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
          }}
          title="Cerrar Sesión"
        >
          {/* @ts-ignore */}
          <FiLogOut />
        </motion.button>
      </div>
    </motion.nav>
  );
};
